function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _objectWithoutProperties(source, excluded) {
    if (source == null) return {};
    var target = _objectWithoutPropertiesLoose(source, excluded);
    var key, i;
    if (Object.getOwnPropertySymbols) {
        var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceSymbolKeys.length; i++){
            key = sourceSymbolKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Flex } from "sprout-ui-primitives";
import styled, { css } from "styled-components";
import { themeGet, media } from "sprout-ui-theme";
import usePageDroppable from "@sprout/client-lib/dist/usePageDroppable";
import PageHeader from "./PageHeader";
const showAside = `
  display: flex;
  + main {
    margin-left: 260px;
  }
`;
const Aside = styled(Flex)`
  display: none;
  position: fixed;
  top: 56px;
  bottom: 0;
  width: 260px;
  background: ${themeGet("colors.white.100")};

  ${media.up("medium", "pointer")} {
    ${showAside};
  }

  ${media.up("large", "touch")} {
    ${showAside};
  }
`;
const MaxWidthWrapper = styled(Flex)`
  ${({ variant  })=>variant === "shadow" && css`
      ${media.up("medium", "pointer")} {
        margin-top: 16px;
      }
    `}
`;
const Wrapper = styled(Flex)`
  ${({ isDraggingOver  })=>isDraggingOver && css`
      position: relative;

      ::before {
        border: 1px solid ${themeGet("colors.yellow.200")};
        position: absolute;
        top: 0;
        left: -16px;
        bottom: 0;
        right: -16px;
        background: rgba(255, 217, 83, 0.18);
        content: "";
        z-index: 2;
        border-radius: inherit;

        ${media.up("medium", "pointer")} {
          left: 0;
          right: 0;
        }
      }
    `}

  ${({ variant , fullHeight  })=>variant === "shadow" && css`
      ${media.up("medium", "pointer")} {
        box-shadow: 0 0 0 ${themeGet("colors.black.10")};
        border-radius: ${fullHeight ? "30px 30px 0 0" : "30px"};

        background: ${themeGet("colors.white.100")};
      }
    `}

  ${({ fullHeight  })=>fullHeight ? css`
          flex: 1 0 auto;
        ` : css`
          margin-bottom: 48px;
        `}
`;
const Content = styled(Flex)`
  padding-bottom: 48px;

  ${({ variant , fullHeight  })=>variant === "shadow" && css`
      ${media.up("medium", "pointer")} {
        padding-left: ${fullHeight ? 64 : 48}px;
        padding-right: ${fullHeight ? 64 : 48}px;
      }
    `}

  ${({ offsetWithPadding  })=>offsetWithPadding && css`
      ${media.up("medium", "pointer")} {
        padding-top: ${typeof offsetWithPadding === "string" ? offsetWithPadding : "64px"};
      }
    `}
`;
const AppBarWrapper = styled(Flex)`
  ${({ sticky  })=>sticky && css`
      position: sticky;
      top: 56px;
      z-index: 2;

      body.banner & {
        top: 88px;
      }
    `}

  display: none;
  ${media.up("medium", "pointer")} {
    display: flex;
  }
`;
var Page = (props)=>{
    const { offsetWithPadding , aside , children , variant ="normal" , fullHeight =true , toolbar , stickyAppBar , appBar , title , aboveTitle , titleDivider , beforeTitle , afterTitle , description , banner , onDrop , obscure ,  } = props;
    let { maxWidth  } = props;
    let paddingX = 64;
    if (!fullHeight) paddingX = 48;
    if (!maxWidth) maxWidth = 952;
    if (variant === "shadow") maxWidth += paddingX * 2;
    // const { goBack } = useGoBack();
    const _ref = usePageDroppable({
        onDrop
    }), { isDraggingOver  } = _ref, rest = _objectWithoutProperties(_ref, [
        "isDraggingOver"
    ]);
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            aside && /*#__PURE__*/ _jsx(Aside, {
                as: "aside",
                flexDirection: "column",
                children: aside
            }),
            /*#__PURE__*/ _jsx(Flex, {
                as: "main",
                flexDirection: "column",
                flex: "1 0 auto",
                px: "16px",
                alignItems: "center",
                children: /*#__PURE__*/ _jsxs(MaxWidthWrapper, {
                    flexDirection: "column",
                    flex: "1 0 auto",
                    maxWidth: aside ? maxWidth + 260 : maxWidth,
                    width: "100%",
                    variant: variant,
                    children: [
                        banner,
                        /*#__PURE__*/ _jsxs(Wrapper, _objectSpread({
                            flexDirection: "column",
                            maxWidth: maxWidth,
                            variant: variant,
                            fullHeight: fullHeight,
                            isDraggingOver: isDraggingOver
                        }, rest, {
                            children: [
                                appBar && /*#__PURE__*/ _jsx(AppBarWrapper, {
                                    bg: "white.95",
                                    alignItems: "center",
                                    height: "64px",
                                    borderRadius: "inherit",
                                    py: 1,
                                    px: 3,
                                    sticky: !!stickyAppBar,
                                    className: "PageAppBar",
                                    children: appBar
                                }),
                                /*#__PURE__*/ _jsxs(Content, {
                                    flexDirection: "column",
                                    flex: "1 0 auto",
                                    fullHeight: fullHeight,
                                    variant: variant,
                                    offsetWithPadding: typeof offsetWithPadding !== "undefined" ? offsetWithPadding : !appBar,
                                    children: [
                                        title && /*#__PURE__*/ _jsx(PageHeader, {
                                            title: title,
                                            titleDivider: titleDivider,
                                            aboveTitle: aboveTitle,
                                            beforeTitle: beforeTitle,
                                            afterTitle: afterTitle,
                                            description: description
                                        }),
                                        children
                                    ]
                                }),
                                toolbar
                            ]
                        })),
                        obscure
                    ]
                })
            })
        ]
    });
};
export { Page };
export default Page;
